import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WeatherLogPage } from './weather-log';
import { WeatherLogComponent } from '../weather-log-component/weather-log-component.component';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { GridModule, RowFilterModule } from '@progress/kendo-angular-grid';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { DailyLogPageModule } from '../../daily-log/daily-log/daily-log.module';
import { SharedModule } from '../../shared/shared.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    WeatherLogPage,
    WeatherLogComponent
  ],
  imports: [
    IonicPageModule.forChild(WeatherLogPage),
    DropDownListModule,
    SharedModule,
    GridModule,
    TabStripModule,
    DailyLogPageModule,
    SharedModule,
    RowFilterModule,
    DirectivesModule,
  ],
})
export class WeatherLogPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-log/weather-log.module.ts